module.exports = __webpack_public_path__ + "static/header-aa8669fa12bdd44d018bf3aeaf831d45.jpg";